import 'document-register-element';
import * as SmoothScroll from 'smoothscroll-polyfill';
import localeAction from '../Helper/localeAction';
import StoreSetup from '../Helper/StoreSetup';
import { LoggerPlugin, StorePlugin } from '../Plugins';
import Vue from 'vue';
import '../../styles/styles.scss';
SmoothScroll.polyfill();
Vue.use(LoggerPlugin);
Vue.use(StorePlugin);
var initialApplicationSetup = function () {
    var contextObject = localeAction();
    StoreSetup.initialApplicationSetup(contextObject);
};
export default initialApplicationSetup;
